import { defineFeatureFlag } from './state';

export type { FeatureFlag, FeatureFlagMeta, FeatureFlagOptions } from './state';

/**
 * Define feature flags here. Each flag is a `Ref<boolean>` backed by localStorage.
 *
 * ```ts
 * export const myFlag = defineFeatureFlag('my-flag', {
 *   default: false,
 *   title: 'My Flag',
 *   description: 'Enables my feature',
 * });
 * ```
 *
 * Use in components:
 *
 * ```vue
 * <script setup lang="ts">
 * import { myFlag } from '#layers/base/utils/feature-flags';
 *
 * if (myFlag.value) {
 *   // do something
 * }
 * </script>
 *
 * <template>
 *   <div v-if="myFlag">Feature enabled!</div>
 * </template>
 * ```
 */

export const gridLayoutBlockDebugFlag = defineFeatureFlag('grid-layout-block-debug', {
	default: false,
	title: 'Grid Layout Block Debug',
	description: 'Enables the grid layout debugger in the block editor',
});

export const virtualizeColumnAutosizeOnScrollFlag = defineFeatureFlag('virtualize-column-autosize-on-scroll', {
	default: false,
	title: 'Virtualized Table Autosize On Scroll',
	description: 'Remeasures auto-sized virtualized listing columns while rows recycle during scroll',
});
